import FolderCardContent from './FolderCardContent';
import connect from './FolderCardContent.container';
export default connect(FolderCardContent);
//# sourceMappingURL=index.js.map